import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  GetProvidersByServiceEnvelope,
  normalizeProvidersByServiceEnvelope,
  parseProvidersByServiceGraphqlError,
} from 'src/app/cuadro-picnic/lib/get-providers-by-service';
import { GraphService } from 'src/app/services/api/graph.service';

@Injectable({
  providedIn: 'root',
})
export class SourcingService {
  constructor(private readonly graphService: GraphService) {}

  /**
   * Queries providers offering a given service from the Sourcing catalog.
   *
   * @param nombreServicio - Name of the service to query providers for.
   * @param categoriaServicio - Category of the service (optional).
   * @param locacion - Location of the service (optional).
   * @returns Observable emitting the normalized GetProvidersByServiceEnvelope.
   * @throws GetProvidersByServiceClientError when GraphQL errors are present in the response.
   */
  public getProvidersByService(
    nombreServicio: string,
    categoriaServicio: string = '',
    locacion: string = '',
  ): Observable<GetProvidersByServiceEnvelope> {
    return this.graphService
      .queryGraphQLSourcingEnvelope<{
        getProvidersByService: GetProvidersByServiceEnvelope | null;
      }>({
        query: `
          query GetProvidersByService(
            $nombreServicio: String!
            $categoriaServicio: String
            $locacion: String
          ) {
            getProvidersByService(
              nombreServicio: $nombreServicio
              categoriaServicio: $categoriaServicio
              locacion: $locacion
            ) {
              success
              code
              message
              data {
                tipoProveedor
                id
                nombre
                correoReserva
                servicioId
                tarifa {
                  id
                }
              }
            }
          }
        `,
        variables: { nombreServicio, categoriaServicio, locacion },
      })
      .pipe(
        map((response) => {
          if (response.errors?.length) {
            throw parseProvidersByServiceGraphqlError(response.errors);
          }
          return normalizeProvidersByServiceEnvelope(
            response.data?.getProvidersByService,
          );
        }),
      );
  }

  queryGetAllServiciosAlimentos(): Observable<{
    getAllServicesByType: any[];
  }> {
    return this.graphService.queryGraphQLSourcing<{
      getAllServicesByType: any[];
    }>({
      query: `query{
        getAllServicesByType(tipo:"ALIMENTOSYBEBIDAS", categoria:"",hasTarifa:false) {
          nombreServicio
          id
          proveedorNombre
          menu{
            id
            nombreMenu
          }
          estadoServicio
          proveedor {
            id
            nombre
          }
          locacion
          categoriaServicio
        }
      }`,
      variables: {},
    });
  }
  queryGetProvider(id: string) {
    return this.graphService.queryGraphQLSourcing<any>({
      query: `query GetProvider($id:String!){
        getProvider(id:$id){
          id,
          nombre
        }
      }`,
      variables: { id },
    });
  }

  queryGetServiceById(id: string): Observable<{
    getServiceById: any;
  }> {
    return this.graphService.queryGraphQLSourcing<{
      getServiceById: any;
    }>({
      query: `query GetServiceById($id:String!){
        getServiceById(id:$id){
            id,
            nombreServicio,
            menu{
              id,
              nombreMenu,
              descripcion
            }
        }
      }`,
      variables: { id },
    });
  }

  assignMenuToServicio(
    id: string,
    menu: any,
  ): Observable<{
    assignMenuToService: any;
  }> {
    return this.graphService.mutateGraphQLSourcing<{
      assignMenuToService: any;
    }>({
      mutation: `mutation assignMenuToService($id:String!, $menu: inputMenu_Dto!){
        assignMenuToService(id:$id, menu: $menu){
          id
          menu{
          nombreMenu
          }
        }
      }`,
      variables: { id, menu },
    });
  }
}
